<div class="mr-2 ml-3">
  <app-day-parting-inputs
    [strategy]="strategy"
    [locale]="modalData.locale"
    [isInModal]="true"
    [placeholderPause]="modalData.dayPartingPauseHour"
    [placeholderReactivation]="modalData.dayPartingReactivationHour"
    [placeholderSwitch]="true"
    (daypartingConfig)="daypartingConfig.set($event)"
  ></app-day-parting-inputs>
</div>
<div class="mt-4 flex justify-end gap-2" *transloco="let t">
  <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>

  <button iButton type="submit" size="md" [loading]="isUpdatingDayparting()" (click)="onSave()">
    {{ t("common.save") }}
  </button>
</div>
